import { alpha, styled } from '@mui/material';
import { common } from '@mui/material/colors';

export const ViewerControlsRoot = styled('div')({
  position: 'absolute',
  zIndex: 12,
  left: '50%',
  bottom: '4rem',
  transform: 'translate(-50%, 0)',
  backgroundColor: common.white,
  border: `0.1rem solid ${alpha(common.black, 0.12)}`,
  borderRadius: '0.3rem',
  padding: '0.5rem',
  display: 'flex',
  alignItems: 'stretch',
  gap: '0.5rem',
});
